import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function PainPoints() {
  const points = ['Siempre sos vos la que inicia, sostiene y empuja el vínculo', 'Te enganchás con hombres fríos, confusos o emocionalmente indisponibles', 'Te responden cuando quieren y aun así seguís esperándolos', 'Te ilusionás rápido y al poco tiempo llega el ghosting, la distancia o las migajas', 'Tenés miedo de pedir claridad porque sentís que si hablás lo vas a espantar', 'Sabés que valés pero en el amor terminás aceptando siempre menos de lo que merecés', 'Algo en vos repite el mismo patrón aunque cambie el nombre del hombre', 'Te cansaste de manifestar, meditar y soltar... y seguís sufriendo por amor igual'];
  return <section className="py-20 px-4 bg-mystic-900 relative" data-id="element-172">
      <div className="max-w-3xl mx-auto" data-id="element-173">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-174">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-175">
            Si sos mujer, esto <br className="hidden sm:block" data-id="element-176" />
            <span className="text-lilac-400" data-id="element-177">
              te va a sonar demasiado conocido:
            </span>
          </h2>
        </motion.div>

        <div className="space-y-4 mb-16" data-id="element-178">
          {points.map((point, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex items-start gap-4 p-4 rounded-xl bg-mystic-800/30 border border-mystic-700/50 hover:border-lilac-500/30 transition-colors" data-id="element-179">
              <div className="mt-1 flex-shrink-0 w-6 h-6 rounded-full bg-red-500/10 flex items-center justify-center" data-id="element-180">
                <X className="w-4 h-4 text-red-400" data-id="element-181" />
              </div>
              <p className="text-slate-200 text-lg" data-id="element-182">{point}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-183">
          <h3 className="text-2xl md:text-3xl font-serif font-bold text-gold-400 italic" data-id="element-184">
            "¿Cuántas veces más vas a elegir a alguien que no te elige?"
          </h3>
        </motion.div>
      </div>
    </section>;
}